import React, { Component } from "react";
import InputMask from 'react-input-mask';
import { BrowserRouter as Router, Route, Switch, NavLink, Redirect } from "react-router-dom";
import { translate } from 'react-i18next';
import RulesNonCustomer from "../../../../copms/Modal/RulesNonCustomerModal";
import ConfirmPinModal from "../../../../copms/Modal/ConfirmPinModal";
import { request } from "../../../../config";

class Step1 extends Component {

    state = {
        feedbackMessage: null,
        isDisabled: true,
        openRules: false,
        openPin: false,
    }

    validateData = (inputType, event) => {
        this.setState({ checkedData: false, feedbackMessage: null });
        if (inputType === 'userId') {
            this.userId.value = this.userId.value.replace(/\D/g, '');
            if (this.userId.value.length < 6) {
                this.setState({ validateUserId: false });
            }
            else {
                if (this.userId.value.length > 6) {
                    this.userId.value = this.userId.value.substring(0, 6);
                }
                this.setState({ validateUserId: true });
            }
        }
        if (inputType === 'phoneNumber') {
            setTimeout(() => {
                if (this.phoneNumber.value.indexOf("_") === -1) {
                    this.setState({ validatePhoneNumber: true });
                }
                else {
                    this.setState({ validatePhoneNumber: false });
                }
            }, 1)
        }
        setTimeout(() => {
            if (this.state.validateUserId && this.state.validatePhoneNumber) {
                this.setState({ isDisabled: false });
            }
            else {
                this.setState({ isDisabled: true });
            }
        }, 1);
    }


    setPasswordVisibility = (name) => {
        this.setState({ [name]: !this.state[name] });
    }

    getPhoneNumber = (phoneNumber) => {
        ['+', '-', '(', ')', ' '].forEach((char) => {
            while (phoneNumber.indexOf(char) !== -1) {
                phoneNumber =
                    phoneNumber.slice(0, phoneNumber.indexOf(char)) +
                    phoneNumber.slice(phoneNumber.indexOf(char) + 1, phoneNumber.length);
            }
        });
        return phoneNumber;
    };

    getAuthInfoRegister = () => {
        this.props.updateAppState('isLoadingTransparentBackground', true);

        let getAuthInfoRegisterRequestBody = {
            userId: this.userId.value,
            phoneNumber: this.getPhoneNumber(this.phoneNumber.value),
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
        };

        fetch(request(`register/nonBankCustomer/${this.props.location.pathname.includes('/juridical') ? "getAuthInfoJuridicalRegister" : "getAuthInfoIndividualRegister"}`, getAuthInfoRegisterRequestBody))
            .then((res) => res.json())
            .then((getAuthRegisterResponse) => {
                if (getAuthRegisterResponse.status.statusCode !== 1) {
                    this.setState({ feedbackMessage: this.props.t(getAuthRegisterResponse.status.statusCode) });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
                else {
                    this.setState({ openPin: true, verificationCode: getAuthRegisterResponse.verificationCode, sessionId: getAuthRegisterResponse.sessionId, token: getAuthRegisterResponse.token }, () => this.registerWithAsan())
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    registerWithAsan = () => {
        let registerWithAsanv1RequestBody = {
            sessionId: this.state.sessionId,
            token: this.state.token,
            lang: localStorage.getItem('i18nextLng').toUpperCase(),
        };

        if (this.props.location.pathname.includes('/juridical')) {
            registerWithAsanv1RequestBody.mobile = this.getPhoneNumber(this.phoneNumber.value)
            registerWithAsanv1RequestBody.userId = this.userId.value
        }

        fetch(request(`register/nonBankCustomer/${this.props.location.pathname.includes('/juridical') ? "registrationJuridicalForAsan" : "registerWithAsanv1"}`, registerWithAsanv1RequestBody))
            .then((res) => res.json())
            .then((registerWithAsanv1Response) => {
                if (registerWithAsanv1Response.status.statusCode !== 1) {
                    this.setState({ openPin: false, feedbackMessage: this.props.t(registerWithAsanv1Response.status.statusCode) });
                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
                else {
                    if (registerWithAsanv1Response.company) {
                        for (let i = 0; i < registerWithAsanv1Response.company.length; i++) {
                            let companyId = "";
                            if (typeof (registerWithAsanv1Response.company[i].token) === 'object' && registerWithAsanv1Response.company[i].token.hasOwnProperty('c')) {
                                registerWithAsanv1Response.company[i].token.c.forEach(part => {
                                    companyId += part;
                                });
                            }
                            else {
                                companyId += registerWithAsanv1Response.company[i].token;
                            }
                            registerWithAsanv1Response.company[i].token = companyId;
                        }
                    }
                    this.setState({ openPin: false }, () => this.props.history.push(`asan/confirmation${this.props.location.pathname.includes('/juridical') ? "/company" : ""}`, { token: registerWithAsanv1Response.token, userId: this.userId.value, mobile: this.getPhoneNumber(this.phoneNumber.value), companies: registerWithAsanv1Response?.company }))

                    this.props.updateAppState('isLoadingTransparentBackground', false);
                }
            },
                (error) => {
                    this.props.history.push("/technical-break");
                });
    }

    render() {
        let { openRules, openPin, isDisabled, verificationCode, feedbackMessage } = this.state;
        let { t } = this.props;
        return (
            <>
                <RulesNonCustomer open={openRules} function={() => this.setState({ openRules: false }, () => this.getAuthInfoRegister())} closeFunction={() => this.setState({ openRules: false })} />
                <ConfirmPinModal open={openPin} {...this.props} feedbackMessage={feedbackMessage} verificationCode={verificationCode} />

                <form className="header-sign-section-container-form">
                    <div className="header-sign-section-container-form-group">
                        <label className="header-sign-section-container-form-group-label">{t('Asan number')}</label>
                        <div className="header-sign-section-container-form-group-box">
                            <InputMask mask="+\9\9\4 99 999-99-99" className="header-sign-section-container-form-group-box-input header-sign-section-container-form-group-box-input-new" placeholder="+994 XX XXX XX XX" ref={(input) => { this.phoneNumber = input }} onInput={this.validateData.bind(this, 'phoneNumber')} />
                        </div>
                    </div>
                    <div className="header-sign-section-container-form-group">
                        <label className="header-sign-section-container-form-group-label">{t('Asan user ID')}</label>
                        <div className="header-sign-section-container-form-group-box">
                            <input type="text" className="header-sign-section-container-form-group-box-input header-sign-section-container-form-group-box-input-new" placeholder={t('Asan user ID')} ref={(input) => { this.userId = input }} onInput={this.validateData.bind(this, 'userId')} />
                        </div>
                    </div>
                    <div className="registration-container-validation-feedback">
                        {
                            feedbackMessage ? <p className="registration-container-validation-feedback-message">{feedbackMessage}</p> : null
                        }
                    </div>
                    <div className="header-sign-section-container-form-group">
                        <a href="https://asanimza.az/" target="_blank">{t('What is ASAN İmza')}</a>
                    </div>
                    <button className="header-sign-section-container-form-button"
                        disabled={isDisabled}
                        onClick={(event) => { event.preventDefault(); this.setState({ openRules: true }) }}>{t('login')}</button>
                </form>
            </>
        )
    };
};

export default translate("translation")(Step1);
